module.exports = __webpack_public_path__ + "img/asset12x1.e7a99b41.png";